import type { Site } from '../Site';

export const TheReset: Site = {
  id: 'thereset',
  analyticsName: 'thereset',
  selector: '',
  logo: '',
  label: 'The Re|set',
  platform: '',
};
